import React, { Component, Fragment } from 'react';
import ProTypes from 'prop-types';
import { connect } from 'react-redux';
import GoogleLoginButton from '../components/GoogleLoginButton';

class Login extends Component {
  constructor() {
    super();
    this.state = {
      email: '',
      loading: false,
      openForgetPassword: false,
      errors: null,
      profile: null,
      error_google_login: null,
    }
  }
  componentWillReceiveProps(nextProps){
    if(nextProps.UI.errors) {
      this.setState({ errors: nextProps.UI.errors });
    }
  }

  responseGoogle = (response) => {
    if(response) {
      const token = {
        token: response.tokenId,
      };
      this.props.loginUser(token, this.props.history);
      this.setState({
        profile: {
          fullname: response.profileObj.name,
          avatar: response.profileObj.imageUrl,
        }
      })
    } else {
      this.setState({
        error_google_login: {
          message: 'Lỗi đăng nhập, vui lòng thử lại sau.'
        }
      })
    }
  }

  render() {
    const { UI: { loading, message } } = this.props;
    const { error_google_login, profile } = this.state;
    return (
      <Fragment>
      <div className="bg-fixed login-page">
        <div className="box center text-center">
          {message ?
          <>
            <p className="text-center">{message}<br />
            Trình duyệt đang tự động chuyển...
            </p>
          </>
          : profile ?
          <div className="profile-login">
            <img src={profile.avatar} alt={profile.fullname} />
            <h3>Welcome, {profile.fullname}</h3>
          </div>
          :
          <>
          <h1 className="text-white">NTEA CMS</h1>
          <GoogleLoginButton history={this.props.history} setProfile={(profile) => this.setState({profile})} setErrorLogin={(error_google_login) => this.setState({error_google_login})} />
          </>
          }
          {error_google_login &&
          <div className="alert-box">
            <p>{error_google_login.message}</p>
          </div>
          }
        </div>
      </div>
      <div className={`overlay-to-right ${loading ? 'show' : ''}`} />
      </Fragment>
    )
  }
}

Login.propTypes = {
  UI : ProTypes.object.isRequired,
}

const mapStateToProps = (state) => ({
  UI: state.UI
});
export default connect(mapStateToProps, null)(Login);
